'use client';

import { memo } from 'react';

import Image from 'next/image';
import { useRouter } from 'next/navigation';

import { blobUrl } from '@/features/v2/constants/variables';
import { homeV2 } from '@/features/v2/home/components/privateHome/localization/core';
import { HButton } from '@/stories/atoms/buttons/mainButton/Button';

import './tournament.css';

const TournamentSection = () => {
  const router = useRouter();
  return (
    <section
      className="flex flex-col  gap-4  justify-center items-center mt-7 md:bg-[radial-gradient(71.39%_51.03%_at_50%_50%,rgba(138,43,226,0.7)_0%,rgba(138,43,226,0)_98%)] w-screen md:w-full relative"
      style={{
        backgroundImage: `url('${blobUrl}/ui/home/Bgdesafios.webp')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
      }}
    >
      <div className="fade-top" />
      {/* Neon Box */}
      <div className="relative w-[320px] h-[125px] -rotate-3 mt-7">
        {/* Resplandor ambiental */}
        <div className="absolute -inset-5 bg-gradient-radial from-cyan-500/10 to-transparent rounded-[25px] animate-ambient-glow" />

        {/* Marco principal con líneas discontinuas */}
        <div className="w-full h-full relative">
          {/* Línea superior discontinua */}
          <div className="absolute top-0 left-[20px] w-[100px] h-[3px] bg-cyan-400 shadow-neon-lines animate-flicker-frame" />
          <div className="absolute top-0 left-[200px] w-[100px] h-[3px] bg-cyan-400 shadow-neon-lines animate-flicker-frame" />

          {/* Línea inferior discontinua */}
          <div className="absolute bottom-0 left-[20px] w-[60px] h-[3px] bg-primary-600 shadow-neon-lines animate-flicker-frame" />
          <div className="absolute bottom-0 left-[100px] w-[200px] h-[3px] bg-primary-600 shadow-neon-lines animate-flicker-frame" />
          {/* Línea izquierda discontinua */}
          <div className="absolute left-0 top-[20px] w-[3px] h-[90px] bg-primary-600 shadow-neon-lines animate-flicker-frame" />

          {/* Línea derecha discontinua */}
          <div className="absolute right-0 top-[20px] w-[3px] h-[90px] bg-primary-600 shadow-neon-lines animate-flicker-frame" />

          <div className="absolute inset-0 flex-col items-center justify-center p-8">
            <h5 className="text-white text-2xl font-bold">{homeV2.tournament.title}</h5>
            <h6 className="text-white text-2xl font-bold">{homeV2.tournament.subtitle}</h6>
          </div>
        </div>

        {/* Botón de play */}
        <div className="absolute -top-[25px] left-1/2 transform -translate-x-1/2 w-[50px] h-[50px] border-[3px] border-cyan-400 rounded-full flex items-center justify-center bg-[#0a0a0a] shadow-neon-button animate-flicker-button">
          <div className="w-0 h-0 border-l-[12px] border-primary-600 border-t-[8px] border-t-transparent border-b-[8px] border-b-transparent ml-[3px] drop-shadow-neon-triangle animate-flicker-triangle" />
        </div>
      </div>
      <div className="flex md:flex-row flex-col gap-2 md:gap-5 justify-center items-center md:w-full md:max-w-6xl mt-5">
        <Image src="/img/v2/home/pagesPromotions/torneo.webp" alt="Challenge" width={300} height={200} className="mx-auto" />
        <div className="flex flex-col gap-4 justify-center items-center md:items-start md:w-1/2 md:mx-7 px-4">
          <p className="text-base text-white/85 text-center md:text-left">
            {homeV2.tournament.description}
            {' '}
            <span className=" font-bold text-primary-500">{homeV2.tournament.span}</span>
            {' '}
            {homeV2.tournament.and}
            <br />
            {' '}
            <span className="font-bold text-white">{homeV2.tournament.span2}</span>
            {' '}
            {homeV2.tournament.and2}
          </p>
          <HButton
            label={homeV2.tournament.textLink}
            mode="secondary"
            size="medium"
            onPress={() => {
              router.push(homeV2.tournament.link);
            }}
            fat
            disabled={false}
          />
        </div>
      </div>
    </section>
  );
};

export default memo(TournamentSection);
